module.exports = __webpack_public_path__ + "img/Weapon_254.ee121cda.png";